// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ListSection_wrapper__2Kwzw {\n  margin-bottom: 50px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ListSection_wrapper__2Kwzw"
};
module.exports = exports;
